import React from 'react';

import { useAuth } from '../Auth';

import { SiteRoutesContext } from './SiteRoutesContext';
import { Routes } from './Routes';
export type SiteRoutesProviderProps = {
  currentPath?: string;
};
export const SiteRoutesProvider: React.FC<SiteRoutesProviderProps> = ({
  children,
  currentPath,
}) => {
  const { logout, isAuthenticated, isLoading: isAuthLoading } = useAuth();

  const isSecureRoute = (current: string) => {
    return Object.values(Routes).some((item) => {
      if (!('secured' in item)) return false;
      return item.secured && item.route.isMatch(current);
    });
  };

  React.useEffect(() => {
    if (!!isAuthLoading) return;
    if (!isAuthenticated && currentPath && isSecureRoute(currentPath)) {
      logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isAuthLoading, currentPath]);

  return (
    <SiteRoutesContext.Provider value={{ routes: Routes, currentPath }}>
      {children}
    </SiteRoutesContext.Provider>
  );
};
